module.exports = __webpack_public_path__ + "img/skill.9842762c.svg";